import { useState } from "react"
import { useForm } from "react-hook-form"
import { Button, Form } from "react-bootstrap"
import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Typography } from "@mui/material";
import { editUserSchema, onSubmitEdit, userSchema } from "./handlers"
import TextInput from "../../components/ReactHookForm/TextInput";

const FormEditarUsuario = (props) => {
  const { usuario, setEditUserFormIsOpen } = props
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, formState: { errors, dirtyFields: dirtyFields2 }, } = useForm({
    mode: "all",
    defaultValues: {
      id: usuario.id,
      password: '',
      repeatPassword: '',
    }, resolver: yupResolver(userSchema)
  })

  return (
    <Form onSubmit={handleSubmit((data) => onSubmitEdit(data, setIsLoading, setEditUserFormIsOpen))}>
      <fieldset disabled={isLoading}>
        <TextInput name='id' label='ID *' register={register} errors={errors?.id} disabled={true} />
        <TextInput name='password' label='Contraseña *' register={register} errors={errors?.password} />
        <TextInput name='repeatPassword' label='Confirmar Contraseña *' register={register} errors={errors?.repeatPassword} />
        <Typography variant='subtitle2' style={{ color: '#006BB1', textTransform: 'italic' }}>
          <i>
            Los campos marcados con * son requeridos.
          </i>
        </Typography>
        <Box className="d-flex justify-content-start mt-3">
          {!isLoading && (
            <Box className='d-flex flex-wrap gap-2'>
              <Button type="submit" disabled={Object.keys(dirtyFields2).length === 0} >
                Guardar
              </Button>
              <Button variant='danger' onClick={() => setEditUserFormIsOpen(false)}>
                Cancelar
              </Button>
            </ Box>
          )}
        </Box>
      </fieldset>
    </Form >
  )
}

export default FormEditarUsuario